import DocumentComponents from "./DocumentComponents";

export default DocumentComponents;
